export default __webpack_public_path__ + "static/media/download.d0b17c55.svg";